import useSound from 'use-sound/dist/index'

import pip from '@lyrahealth-inc/ui-core-crossplatform/src/assets/sounds/pip.wav'

/**
 * Hook to play a sound when a new message comes into the messenger
 * Sound Info: 16bit-mono
 * This hook encapsulates useSound:
 * https://github.com/joshwcomeau/use-sound
 * To return the sound created by @nickjohnson
 */
export const useNewMessageSound = () => useSound(pip)
